"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateConfig = exports.updataDrawTime = exports.startDraw = exports.isDrop = exports.insertConfig = exports.getDrawTime = exports.getConfigsList = exports.getConfig = exports.drapList = exports.deleteConfig = exports.addDrawTime = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
// 新增抽签时间
var addDrawTime = exports.addDrawTime = function addDrawTime(data) {
  return _api.default.request({
    url: '/common/insertConfigs',
    method: 'post',
    data: data
  });
};

// 获取设置的抽签时间
var getDrawTime = exports.getDrawTime = function getDrawTime(data) {
  return _api.default.request({
    url: '/common/getConfigs',
    method: 'post',
    data: _qs.default.stringify(data)
    // data:data
  });
};
// 根据id获取数据
var getConfig = exports.getConfig = function getConfig(data) {
  return _api.default.request({
    url: '/common/getConfig',
    method: 'post',
    data: _qs.default.stringify(data)
    // data:data
  });
};
var insertConfig = exports.insertConfig = function insertConfig(data) {
  return _api.default.request({
    url: '/common/insertConfig?businessId=' + data.businessId,
    method: 'post',
    data: data
    // data:data
  });
};
var updateConfig = exports.updateConfig = function updateConfig(data) {
  return _api.default.request({
    url: '/common/updateConfig',
    method: 'post',
    data: _qs.default.stringify(data)
    // data:data
  });
};
var deleteConfig = exports.deleteConfig = function deleteConfig(data) {
  return _api.default.request({
    url: '/common/deleteConfig',
    method: 'post',
    data: _qs.default.stringify(data)
    // data:data
  });
};

// 获取省下的所有的配置
var getConfigsList = exports.getConfigsList = function getConfigsList(data) {
  return _api.default.request({
    url: '/common/getConfigsList',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};

// 更新设置的抽签时间
var updataDrawTime = exports.updataDrawTime = function updataDrawTime(data) {
  return _api.default.request({
    url: '/common/updateConfigs',
    method: 'post',
    // data:data
    data: _qs.default.stringify(data)
  });
};

// 抽签列表
var drapList = exports.drapList = function drapList(data) {
  return _api.default.request({
    url: '/group/groupList',
    method: 'post',
    data: data
  });
};

// 判断用户是否需要抽签
var isDrop = exports.isDrop = function isDrop(data) {
  return _api.default.request({
    url: '/group/checkNeedRoll',
    method: 'post',
    data: data
  });
};

// 开始抽签
var startDraw = exports.startDraw = function startDraw(data) {
  return _api.default.request({
    url: '/group/roll',
    method: 'post',
    data: data
  });
};